import { Section } from '@/pages/CompanyReport/components/Overview/components/Section';
import { useTracking } from 'react-tracking';
import { Suspense } from 'react';
import { NarrativeCardLoading } from '@/components/NarrativeCard';
import { ErrorBoundary } from '@sentry/react';
import { Alert, AlertAction } from '@simplywallst/ui-core';
import { CompanyNarrativesMain } from './components/CompanyNarrativesMain';
import { FairValueHistogramSkeleton } from '../FairValueHistogram';
import { CompanyNarrativesHeader } from './components/CompanyNarrativesHeader';

const PLACEHOLDER_ITEMS = Array.from({ length: 4 });

type Props = {
  canonicalUrl: string;
};

export const CompanyNarratives = ({ canonicalUrl }: Props) => {
  const { Track } = useTracking({
    type: 'track',
    subject: 'narrative',
  });

  return (
    <Track>
      <Section data-cy-id="company-narratives" style={{ minHeight: 0 }}>
        <ErrorBoundary
          fallback={
            <div>
              <CompanyNarrativesHeader />
              <Alert
                styleType="negative"
                actions={
                  <AlertAction onClick={() => window.location.reload()}>
                    Reload
                  </AlertAction>
                }
              >
                Failed to load company narratives. Please try again.
              </Alert>
            </div>
          }
        >
          <Suspense
            fallback={
              <div className="grid gap-x2">
                <CompanyNarrativesHeader />
                <div className="bones h-x2" />
                <FairValueHistogramSkeleton height={160} />
                <div className="grid overflow-hidden">
                  <section
                    className="grid grid-cols-[repeat(4,317px)] gap-x1"
                    role="presentation"
                    aria-label="Loading skeleton"
                  >
                    {PLACEHOLDER_ITEMS.map((_, index) => (
                      <NarrativeCardLoading showCompanyIcon key={index} />
                    ))}
                  </section>
                </div>
                <div className="bones h-x5" />
              </div>
            }
          >
            <CompanyNarrativesMain canonicalUrl={canonicalUrl} />
          </Suspense>
        </ErrorBoundary>
      </Section>
    </Track>
  );
};
